import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Select,
    Chip,
    Box,
    OutlinedInput,
    MenuItem,
    Alert
} from '@mui/material';
import { useAddRole } from '../../hooks/useRole';
import { useAllPermissions } from '../../hooks/usePermission';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const RoleForm = ({ open, onClose, formData, onInputChange }) => {
    const { mutate: addRole, error } = useAddRole();
    const { data: allPermissions } = useAllPermissions();
    const [validationError, setValidationError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setValidationError('');

        // Basic validation
        if (!formData.name.trim()) {
            setValidationError('Role name is required');
            return;
        }

        // Ensure permissions are included in the form data
        const roleData = {
            name: formData.name.trim(),
            description: formData.description.trim(),
            permissions: formData.permissions || []
        };

        addRole(roleData, {
            onSuccess: () => {
                onClose();
            },
            onError: (error) => {
                setValidationError(error.message || 'An error occurred while creating the role');
            }
        });
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Add New Role</DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent>
                    {(validationError || error) && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {validationError || error?.message}
                        </Alert>
                    )}
                    <TextField
                        autoFocus
                        margin="dense"
                        name="name"
                        label="Role Name"
                        type="text"
                        fullWidth
                        value={formData.name}
                        onChange={onInputChange}
                        required
                        error={!!validationError}
                    />
                    <TextField
                        margin="dense"
                        name="description"
                        label="Description"
                        type="text"
                        fullWidth
                        value={formData.description}
                        onChange={onInputChange}
                        required
                    />
                    <FormControl fullWidth margin="dense">
                        <InputLabel>Permissions</InputLabel>
                        <Select
                            multiple
                            name="permissions"
                            value={formData.permissions || []}
                            onChange={onInputChange}
                            input={<OutlinedInput label="Permissions" />}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => (
                                        <Chip key={value} label={value} />
                                    ))}
                                </Box>
                            )}
                            MenuProps={MenuProps}
                        >
                            {allPermissions?.map((permission) => (
                                <MenuItem key={permission.id} value={permission.name}>
                                    {permission.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="submit">Create</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default RoleForm; 